import { ENV } from "../Utils";

export class Menu {
  baseApi = ENV.BASE_API; // esto me devuelve http://localhost:3001/api

  async getMenus(active = undefined) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.MENU}?active=${active}`; //esto me devuelve http://localhost:3001/api/menu?active=true
      const response = await fetch(url); //peticion no autenticada porque es get  y no lleva token
      const result = await response.json();
      if (response.status !== 200) throw result;
      // console.log("Result from getMenus:", result);
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createMenu(accessToken, menu) {
    try {
      //console.log("menu", menu);
      //console.log("accessToken", accessToken);
      const url = `${this.baseApi}/${ENV.API_ROUTES.MENU}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(menu),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      console.log("Result from createMenu:", result);
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateMenu(accessToken, idMenu, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.MENU}/${idMenu}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      // console.log("Result from updateMenu:", result);
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteMenu(accessToken, idMenu) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.MENU}/${idMenu}`;
      const params = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      console.log("Result from deleteMenu:", result);
      return result;
    } catch (error) {
      throw error;
    }
  }
}
